(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["an-jacket-grid"]) return;
  try {
    
if (!customElements.get('an-collection-more')) {
  customElements.define('an-collection-more', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.link = this.querySelector('[data-an-more-link]');
      this.onClick = event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
        event.preventDefault();
        this.loadNext();
      };
      this.link?.addEventListener('click', this.onClick);
    }
    disconnectedCallback() { this.link?.removeEventListener('click', this.onClick); this.ready = false; }
    async loadNext() {
      if (this.loading) return;
      const scope = this.closest('collection-component');
      const grid = scope?.querySelector('ul#product-grid');
      if (!grid || !this.link) return;
      const url = new URL(this.link.href, window.location.origin);
      if (url.origin !== window.location.origin) return;
      url.searchParams.set('section_id', this.dataset.section);
      this.loading = true;
      this.setAttribute('aria-busy', 'true');
      this.link.setAttribute('aria-disabled', 'true');
      this.querySelector('[data-an-more-status]').textContent = '';
      this.querySelector('[data-an-more-fallback]').hidden = true;
      try {
        const response = await fetch(url, {credentials:'same-origin', signal:AbortSignal.timeout(10000)});
        if (!response.ok) throw new Error('page');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextScope = [...doc.querySelectorAll('collection-component')].find(node => node.dataset.anCollectionSection === this.dataset.section);
        const nextGrid = nextScope?.querySelector('ul#product-grid');
        if (!nextGrid || !nextGrid.children.length) throw new Error('grid');
        const seen = new Set([...grid.querySelectorAll('[data-an-product-id]')].map(node => node.dataset.anProductId));
        const appended = [];
        [...nextGrid.children].forEach(card => {
          if (seen.has(card.dataset.anProductId)) return;
          seen.add(card.dataset.anProductId);
          card.classList.remove('scroll-trigger','animate--slide-in','scroll-trigger--offscreen');
          grid.append(card);
          appended.push(card);
        });
        const firstLink = appended[0]?.querySelector('a');
        firstLink?.focus({preventScroll:true});
        if (firstLink) firstLink.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});
        const pagination = this.closest('[data-an-pagination]');
        const nextPagination = nextScope.querySelector('[data-an-pagination]');
        if (pagination && nextPagination) pagination.replaceWith(nextPagination);
        else pagination?.remove();
      } catch {
        this.querySelector('[data-an-more-status]').textContent = this.dataset.error;
        this.querySelector('[data-an-more-fallback]').hidden = false;
      } finally {
        this.loading = false;
        this.removeAttribute('aria-busy');
        this.link?.removeAttribute('aria-disabled');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["an-mentor-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('an-brand-hero')) {
  customElements.define('an-brand-hero', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-brand-slide]')];
      this.index = 0;
      this.querySelectorAll('[data-brand-direction]').forEach(button => button.addEventListener('click', () => this.show(this.index + Number(button.dataset.brandDirection))));
      this.querySelectorAll('[data-brand-index]').forEach(button => button.addEventListener('click', () => this.show(Number(button.dataset.brandIndex))));
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight') this.show(this.index + 1);
        if (event.key === 'ArrowLeft') this.show(this.index - 1);
      });
      this.selectHandler = event => { const index = this.slides.findIndex(slide => slide.contains(event.target)); if (index >= 0) this.show(index); };
      document.addEventListener('shopify:block:select', this.selectHandler);
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, number) => { slide.hidden = number !== this.index; });
      this.querySelectorAll('[data-brand-index]').forEach(button => button.setAttribute('aria-current', String(Number(button.dataset.brandIndex) === this.index)));
    }
    disconnectedCallback() { document.removeEventListener('shopify:block:select', this.selectHandler); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["an-mentor-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('an-story-gallery')) {
  customElements.define('an-story-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('.an-story-gallery__track');
      const slides = [...track.children];
      const controls = this.querySelector('.an-story-gallery__controls');
      const dots = this.querySelector('.an-story-gallery__dots');
      if (slides.length < 2) return;
      controls.hidden = false;
      const previous = this.querySelector('[data-story-direction="-1"]');
      const next = this.querySelector('[data-story-direction="1"]');
      let index = 0;
      const paint = () => dots.querySelectorAll('button').forEach((dot, number) => dot.setAttribute('aria-current', String(index === number)));
      const show = number => {
        index = (number + slides.length) % slides.length;
        track.scrollTo({left: index * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        paint();
      };
      slides.forEach((slide, number) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', (number + 1) + ' / ' + slides.length);
        dot.addEventListener('click', () => show(number));
        dots.appendChild(dot);
      });
      previous.addEventListener('click', () => show(index - 1));
      next.addEventListener('click', () => show(index + 1));
      track.addEventListener('scroll', () => { index = Math.round(track.scrollLeft / track.clientWidth); paint(); }, {passive:true});
      track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
      });
      paint();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["an-review-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('an-review-rail')) {
  customElements.define('an-review-rail', class extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('.an-review-carousel__track');
      const reviews = [...track.querySelectorAll('.jdgm-rev')].map((review,index)=>({review,index,score:Number(review.querySelector('[data-score]')?.dataset.score)||0})).sort((a,b)=>b.score-a.score||a.index-b.index).map(entry=>entry.review);
      if (!reviews.length) return;
      const cards = reviews.map(review => {
        const card = document.createElement('article'); card.className = 'an-review-card';card.setAttribute('role','listitem');
        const score = Math.max(0, Math.min(5,Number(review.querySelector('[data-score]')?.dataset.score) || 0));
        const stars = document.createElement('span');stars.className='an-review-card__stars';stars.setAttribute('aria-label',String(score)+' / 5');
        for (let index=0;index<5;index++) {const star=document.createElement('span');star.textContent='★';star.style.setProperty('--star-fill',Math.max(0,Math.min(1,score-index))*100+'%');stars.append(star);}
        const body = document.createElement('p');body.className='an-review-card__body';body.textContent=review.querySelector('.jdgm-rev__body')?.textContent.trim() || '';
        const footer=document.createElement('p');footer.className='an-review-card__author';
        const author=document.createElement('strong');author.textContent=review.querySelector('.jdgm-rev__author')?.textContent.trim() || '';footer.append(author);
        if (review.dataset.verifiedBuyer === 'true') {const verified=document.createElement('span');verified.className='an-review-card__verified';verified.textContent='✓ '+this.dataset.verifiedLabel;footer.append(verified);}
        card.append(stars,body,footer);
        const link=review.querySelector('.jdgm-rev__prod-link a, a.jdgm-rev__prod-link');
        if (link) {const product=link.cloneNode(true);product.className='an-review-card__product';card.append(product);}
        return card;
      });
      track.replaceChildren(...cards);track.setAttribute('role','list');track.classList.add('is-refined');
      const dots=this.querySelector('.an-reviews-refined__dots');
      let perPage=1, pages=1;
      const controls=[...this.querySelectorAll('[data-review-direction]')];
      const position=()=>track.scrollLeft+track.clientWidth>=track.scrollWidth-3?pages-1:Math.round(track.scrollLeft/(track.clientWidth+16));
      const update=()=>{const index=position();controls[0].disabled=track.scrollLeft<3;controls[1].disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-3;[...dots.children].forEach((dot,i)=>{dot.setAttribute('aria-current',String(i===index));dot.hidden=pages>7&&i!==0&&i!==pages-1&&Math.abs(i-index)>2;});const bounds=track.getBoundingClientRect();const visible=cards.filter(card=>{const rect=card.getBoundingClientRect();return rect.right>bounds.left+4&&rect.left<bounds.right-4;});const height=Math.max(0,...visible.map(card=>card.offsetHeight))+12;if(height>12)track.style.height=height+'px';};
      const go=index=>track.scrollTo({left:index*(track.clientWidth+16),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      const layout=()=>{perPage=matchMedia('(min-width:990px)').matches?3:matchMedia('(min-width:750px)').matches?2:1;pages=Math.ceil(cards.length/perPage);dots.replaceChildren();for(let index=0;index<pages;index++){const dot=document.createElement('button');dot.type='button';dot.setAttribute('aria-label',this.dataset.pageLabel+' '+(index+1));dot.addEventListener('click',()=>go(index));dots.append(dot);}update();};
      controls.forEach(button=>button.addEventListener('click',()=>go(position()+Number(button.dataset.reviewDirection))));
      track.addEventListener('scroll',update,{passive:true});
      this.resize=new ResizeObserver(layout);this.resize.observe(track);layout();
    }
    disconnectedCallback(){this.resize?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["an-shop-window"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('an-shop-tabs')) {
  customElements.define('an-shop-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-an-tab]')];
      this.panels = [...this.querySelectorAll('[data-an-panel]')];
      if (!this.tabs.length) return;
      this.querySelector('nav').setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', tab.dataset.anTab);
        const panel = this.panels.find(item => item.id === tab.dataset.anTab);
        panel?.setAttribute('role', 'tabpanel');
        tab.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.activate(index);
        });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.activate(next);
          this.tabs[next].focus({preventScroll:true});
        });
      });
      this.activate(0);
    }
    activate(index) {
      this.tabs.forEach((tab, position) => {
        const active = index === position;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        const panel = this.panels.find(item => item.id === tab.dataset.anTab);
        if (panel) panel.hidden = !active;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["an-sticky-product-bar"]) return;
  try {
    
  document.querySelectorAll('[data-an-sticky-bar]').forEach((bar) => {
    if (bar.dataset.anStickyReady) return;
    bar.dataset.anStickyReady = 'true';
    const productInfo = document.querySelector('product-info');
    const stickyButton = bar.querySelector('[data-an-sticky-submit]');
    const stickyLabel = bar.querySelector('[data-an-sticky-label]');
    const stickyPrice = bar.querySelector('[data-an-sticky-price]');
    const stickyCompare = bar.querySelector('[data-an-sticky-compare]');
    const optionsLabel = bar.querySelector('[data-an-sticky-size]');
    if (!productInfo || !stickyButton || !stickyLabel || !stickyPrice) return;
    let mainButton = null;
    let scheduled = false;
    const desktopQuery = window.matchMedia('(min-width: 750px)');
    const visibilityObserver = new IntersectionObserver(() => scheduleSync(), {threshold: 0});

    const syncState = () => {
      const button = productInfo.querySelector('product-form button[name="add"]');
      if (!button) { bar.hidden = true; return; }
      if (button !== mainButton) {
        if (mainButton) visibilityObserver.unobserve(mainButton);
        mainButton = button;
        visibilityObserver.observe(mainButton);
      }
      const price = productInfo.querySelector('[id^="price-"] .price');
      const currentPrice = price?.classList.contains('price--on-sale')
        ? price.querySelector('.price__sale .price-item--sale')?.textContent.trim()
        : price?.querySelector('.price__regular .price-item--regular')?.textContent.trim();
      if (currentPrice && stickyPrice.textContent.trim() !== currentPrice) stickyPrice.textContent = currentPrice;
      const comparePrice = price?.classList.contains('price--on-sale')
        ? price.querySelector('.price__sale .price-item--regular')?.textContent.trim()
        : '';
      if (stickyCompare) {
        stickyCompare.hidden = !comparePrice;
        if (comparePrice && stickyCompare.textContent.trim() !== comparePrice) stickyCompare.textContent = comparePrice;
      }
      const sizeField = productInfo.querySelector('[data-an-size-option]');
      const text = mainButton.querySelector('span')?.textContent.trim();
      if (text && stickyLabel.textContent !== text) stickyLabel.textContent = text;
      if (text && stickyButton.getAttribute('aria-label') !== text) stickyButton.setAttribute('aria-label', text);
      const picker = productInfo.querySelector('variant-selects');
      const selected = picker ? [
        ...Array.from(picker.querySelectorAll('fieldset')).map(field => field.querySelector('input:checked')?.value),
        ...Array.from(picker.querySelectorAll('select')).map(select => select.value)
      ].filter(Boolean) : [];
      let optionsText = selected.join(' · ');
      if (!optionsText && productInfo.dataset.anSizeChosen && sizeField) {
        optionsText = sizeField.dataset.anSelectedLabel.replace('__SIZE__', productInfo.dataset.anSizeChosen);
      }
      if (optionsLabel && optionsLabel.textContent !== optionsText) optionsLabel.textContent = optionsText;
      const busy = mainButton.classList.contains('loading') || mainButton.getAttribute('aria-disabled') === 'true';
      const disabled = mainButton.disabled || busy;
      if (stickyButton.disabled !== disabled) stickyButton.disabled = disabled;
      stickyButton.classList.toggle('an-is-loading', busy);
      stickyButton.setAttribute('aria-busy', busy ? 'true' : 'false');
      bar.hidden = desktopQuery.matches && mainButton.getBoundingClientRect().bottom >= 0;
    };
    const scheduleSync = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; syncState(); });
    };
    const observer = new MutationObserver(scheduleSync);
    observer.observe(productInfo, {
      attributes: true, childList: true, characterData: true, subtree: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class', 'data-an-size-chosen']
    });
    productInfo.addEventListener('change', scheduleSync);
    stickyButton.addEventListener('click', () => {
      syncState();
      if (stickyButton.disabled) return;
      mainButton?.click();
      scheduleSync();
    });
    desktopQuery.addEventListener('change', scheduleSync);
    syncState();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
